var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasHome)?_c('div',{attrs:{"id":"go-home"},on:{"click":function($event){$event.stopPropagation();return _vm.goBack.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/img/icon-go-home.png"),"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }